import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment'
import { getUserLocale } from '@/lang'

let lang = getUserLocale()
if (lang === 'zh') {
  lang = 'zh-tw'
}

moment.locale(lang)

Vue.use(VueMoment, {
  moment
})
